/* eslint-disable max-len */
import { Alert, Box, Typography } from "@mui/material";
import ContainerPainel from "components/container_painel";
import CardFormularioStatus from "components/forms/CardFormularioStatus";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useFormulariosStore } from "stores/forms/formularios.store";

export default function PacoteFormulariosVisualizar(): JSX.Element {
  const { uuid } = useParams();

  const { formularios, getFormulariosByUUID } = useFormulariosStore();

  useEffect(() => {
    if (uuid) {
      getFormulariosByUUID(uuid);
    }
  }, []);

  // Filtrar CMDRS (ocultar da exibição)
  const formulariosFiltrados = formularios.filter(
    (formulario) => {
      const nameLC = formulario.name.toLowerCase();
      return !(nameLC.includes('conselho municipal de desenvolvimento rural sustentável') || nameLC.includes('cmdrs'));
    }
  );

  return (
    <ContainerPainel pagina='Gerenciar Formulários' showBackButton={true}>
      <Box
        display={'flex'}
        flexDirection={'column'}
        gap={2}
        alignItems={'center'}
        width={'100%'}
      >
        <Box
          paddingTop={2}
          display={'flex'}
          flexDirection={'column'}
          gap={2}
          padding={6}
          maxWidth={'1400px'}


        >
          <Alert

            sx={{ marginY: '2rem', backgroundColor: '#EAEFF9' }}
            severity='info'
          >
            <Typography
              textAlign='left'
              variant='body2'
              lineHeight={1.5}
              fontSize='16px'
            >
              {`Para enviar o pacote de formulários ao Gerente Estadual, certifique-se de que todos os formulários estejam com o status 'Concluido'`}
            </Typography>
          </Alert>

          <Box display={'grid'} gridTemplateColumns={'repeat(2, 1fr)'} gap={2}>
            {formulariosFiltrados.map((formulario, index) => {
              const isLastAndOdd =
                formulariosFiltrados.length % 2 === 1 && index === formulariosFiltrados.length - 1;
              const card = (
                <CardFormularioStatus key={formulario.uuid} {...formulario} hideEditButton={true} />
              );
              if (isLastAndOdd) {
                return (
                  <Box
                    key={formulario.uuid}
                    sx={{
                      gridColumn: '1 / -1',
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    <Box sx={{ width: '100%', maxWidth: 'calc((100% - 16px) / 2)' }}>{card}</Box>
                  </Box>
                );
              }
              return card;
            })}
          </Box>
        </Box>
      </Box>
    </ContainerPainel>
  )
}
